module.exports = __webpack_public_path__ + "static/media/lettering-cmu1.c13ec837.jpg";